import React, { useCallback, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import cx from 'clsx';
import { Table } from './Table';

import { TableProps, SortOrder } from './types';

export const LinkTable = <T extends Record<string, any>>({
  linker,
  className,
  ...rest
}: Omit<TableProps<T>, 'rowRender'> & {
  linker: (row: T) => string;
}) => {
  const rowRender = useCallback(
    ({ row, children, expanded }) => {
      return (
        <NavLink to={linker(row)} className={cx('db-linkTable-row', expanded && 'is-expanded')}>
          {children}
        </NavLink>
      );
    },
    [linker],
  );

  return <Table {...rest} className={cx('db-linkTable', className)} rowRender={rowRender} />;
};

export const WiderTable = <T extends Record<string, any>>({
  className,
  sortBy,
  orderBy,
  showEmpty = true,
  showReload = true,
  ...rest
}: TableProps<T> & {
  orderBy?: string;
}) => {
  const _sortBy: [string, SortOrder][] | undefined = useMemo(() => {
    if (!orderBy) {
      return;
    }
    if (orderBy?.startsWith('-')) {
      return [[orderBy.slice(1), 'desc']];
    }
    return [[orderBy, 'asc']];
  }, [orderBy]);

  return (
    <div className={cx('db-widerTable', className)}>
      <Table
        sortBy={sortBy || _sortBy}
        showEmpty={showEmpty}
        showReload={showReload}
        skeleton
        className={''}
        {...rest}
      />
    </div>
  );
};

export { Table };

export * from './types';
